import { ISalePageDetailV2Response } from '@/api/types';
import { AppImage } from '@/components';
import { getCdnUrl } from '@/utils/image';
import { Column, Element, Row } from '@vuddy/components';
import { formatFullDateExceptSeconds2 } from '@vuddy/utils';
import { groupBy, isEmpty, toPairs } from 'lodash-es';
import * as styles from './titleSection.css';

interface IGachaTitleSectionProps {
  salePage: ISalePageDetailV2Response;
}

export const GachaTitleSection = ({ salePage }: IGachaTitleSectionProps) => {
  const groupedRewardsByGrade = toPairs(
    groupBy(salePage.gacha?.rewards ?? [], 'grade')
  ).filter(([grade]) => !isEmpty(grade));

  return (
    <Column gap="gap_2xl" position="absolute" className={styles.wrapper}>
      <Column gap="gap_xl" alignItems="center" justifyContent="center">
        <Element
          paddingY="padding_4xs"
          paddingX="padding_small"
          backgroundColor="whiteTertiary"
          typography="captionBaseAccent"
          color="whitePrimary"
          width="fit-content"
          borderRadius="radius_2xl">
          {formatFullDateExceptSeconds2(salePage.saleTimeRange.startAt)} ~{' '}
          {salePage.saleTimeRange.endAt
            ? formatFullDateExceptSeconds2(salePage.saleTimeRange.endAt)
            : ''}
        </Element>
        <Element
          typography="headingSmall"
          color="whitePrimary"
          textAlign="center">
          {salePage.name}
        </Element>
      </Column>
      <Column
        className={styles.gradeWrapper}
        borderRadius="radius_large"
        gap="gap_xs"
        alignItems="center">
        <Element typography="bodyXsAccent" color="whitePrimary">
          포함 등급
        </Element>
        <Row
          width="100%"
          className={styles.gradeCardWrapper}
          justifyContent="space-evenly">
          {groupedRewardsByGrade.map(([grade, rewards]) => {
            return (
              <Column gap="gap_2xs" alignItems="center" key={grade}>
                <AppImage
                  src={getCdnUrl(
                    `/images/gacha/grade_${grade.toLowerCase()}.png`
                  )}
                  width={72}
                  height={24}
                  alt={grade}
                />
                <Element typography="captionBaseAccent" color="whitePrimary">
                  {rewards.length}종
                </Element>
              </Column>
            );
          })}
        </Row>
      </Column>
    </Column>
  );
};
